import { render, staticRenderFns } from "./Delete.vue?vue&type=template&id=edc3fb7e&scoped=true&"
import script from "./Delete.vue?vue&type=script&lang=ts&"
export * from "./Delete.vue?vue&type=script&lang=ts&"
import style0 from "./Delete.vue?vue&type=style&index=0&id=edc3fb7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc3fb7e",
  null
  
)

export default component.exports